import { DocHeading } from '../types';
import { slugify } from './slugify';

const HEADING_LINE = /^(##|###)\s+(.+)$/gm;

/** Scans H2/H3 lines from raw markdown, in document order, for the "On this page" TOC. */
export function extractHeadings(markdownBody: string): DocHeading[] {
  const headings: DocHeading[] = [];
  let match: RegExpExecArray | null;

  while ((match = HEADING_LINE.exec(markdownBody)) !== null) {
    const [, hashes, text] = match;
    headings.push({
      id: slugify(text),
      text: text.trim(),
      level: hashes.length === 2 ? 2 : 3,
    });
  }

  return headings;
}
